<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="onReset">
        <el-tab-pane
          v-for="(item,index) in returnMoneyTransferTabs"
          :label="item.title"
          :name="item.name"
          class="tab-text"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="queryParams.column" @change="changeColumn">
                <el-option
                  v-for="(item,index) in contractReturnMoneyTransfer"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
                <el-option v-show="activeName==='1'" label="账户余额" value="accountBalance"></el-option>
                <el-option v-show="activeName==='0'" label="坏账" value="badDebt"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-show="expressionShow">
            <el-form-item>
              <el-select v-model="queryParams.expression">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item,index) in expressionList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-if="queryParams.column==='cusCode'||queryParams.column==='cusName'"
                v-model="queryParams.value"
                placeholder="请输入关键词"
              ></el-input>
              <el-input
                v-else
                v-model="queryParams.value"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button @click="onSearch" type="primary">搜索</el-button>
              <el-button @click="onReset" plain>重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height: $store.state.Sell.height+'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="$store.state.Sell.height"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="cusCode" label="客户编号" :key="0"></el-table-column>
          <el-table-column label="客户名称" min-width="210" show-overflow-tooltip :key="1">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onCusName(scope.row)"
              >{{scope.row.cusName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="贸易总额" min-width="125" :key="2">
            <template slot-scope="scope">{{ scope.row.contractTotal | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="应收账款" min-width="125" :key="3">
            <template slot-scope="scope">{{ scope.row.accountsReceivable | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="已到期账款" min-width="150" :key="4">
            <template slot-scope="scope">{{ scope.row.accountsDue | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="已收账款" min-width="120" :key="5">
            <template slot-scope="scope">{{ scope.row.paymentReceived | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column label="坏账" v-if="activeName==='0'" :key="6">
            <template slot-scope="scope">{{ scope.row.badDebt | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="number" label="待划拨合同数" width="110" :key="7"></el-table-column>
          <el-table-column label="账户余额" min-width="125" v-if="activeName==='1'" :key="8">
            <template slot-scope="scope">{{ scope.row.accountBalance | priceFilterNum }}</template>
          </el-table-column>
          <el-table-column prop="ccContacts" label="联系人" v-if="activeName==='0'" :key="9"></el-table-column>
          <el-table-column prop="ccPhone" label="电话" v-if="activeName==='0'" width="110" :key="10"></el-table-column>
          <el-table-column prop="ccMobile" label="手机" v-if="activeName==='0'" width="110" :key="11"></el-table-column>
          <el-table-column label="欠款起始日" min-width="135" :key="12">
            <template slot-scope="scope">{{scope.row.dueDate | dateFilterD}}</template>
          </el-table-column>
          <el-table-column label="操作" v-if="activeName==='1'" fixed="right" :key="13">
            <template slot-scope="scope">
              <el-button @click="onTransfer(scope.row)" type="text">划拨</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  returnMoneyTransferTabs,
  contractReturnMoneyTransfer
} from './util/data'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { queryTransFlowByOcbId } from '@/api/sell/sellManage'
export default {
  components: { pagination },
  data () {
    return {
      activeName: '1', // tabs状态
      returnMoneyTransferTabs, // tabs数据
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      expressionList,
      contractReturnMoneyTransfer,
      expressionShow: false,
      columnArr: [],
      queryParams: {
        column: 'cusName',
        value: ''
      }
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onCusName (row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
    },
    // 列表数据
    getList () {
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      queryTransFlowByOcbId(
        Number(this.activeName),
        this.currentPage,
        this.pageSize,
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeColumn(val) {
      this.queryParams = {}
      this.queryParams.column = val
      if (
        val !== 'cusCode' &&
        val !== 'cusName' &&
        val !== 'number' &&
        val !== ''
      ) {
        this.$set(this.queryParams, 'expression', 'eq')
        this.expressionShow = true
      } else {
        this.expressionShow = false
      }
    },
    onReset () {
      // 重置
      this.columnArr = []
      this.queryParams = {}
      this.expressionShow = false
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 搜索
    onSearch () {
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 划拨
    onTransfer (row) {
      this.$router.push({ name: 'transferEdit', query: { id: row.cusId } })
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
